import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import {
  Grid,
  CircularProgress,
  Typography,
  Divider,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useOptionService } from 'hooks/useOptionService'
import { useStyles } from '../FormEditarDescricaoTecnica.styles'

export const FormDescricaoVestigioQuimico = (props) => {
  const { formDescricaoTecnica } = props
  const classes = useStyles()
  const optionService = useOptionService()
  
  const [tiposAspectosFisicosSubstanciasQuimicas, setTiposAspectosFisicosSubstanciasQuimicas] = useState([])
  const [processandoAspectosFisicos, setProcessandoAspectosFisicos] = useState(false)

  const fetchTiposAspectosFisicosSubstanciasQuimicas = useCallback(async () => {
    try {
      const response = await optionService.listarOpcoesDeModeloAsync(
        'TIPO_ASPECTO_FISICO_SUBSTANCIA_QUIMICA',
        setProcessandoAspectosFisicos
      )
      setTiposAspectosFisicosSubstanciasQuimicas(response || [])
    } catch (error) {
      console.error('Error fetching physical aspect options:', error)
    }
  }, []) // Excluded optionService to prevent loop

  useEffect(() => {
    fetchTiposAspectosFisicosSubstanciasQuimicas()
  }, [fetchTiposAspectosFisicosSubstanciasQuimicas])

  return (
    <div>
      {processandoAspectosFisicos ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>
          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>QUANTIFICAÇÃO</Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item container className={classes.formContent} spacing={2}>
            <Grid item container xs={12}>
              <Grid item md={3} sm={4} xs={12}>
                <TextField
                  variant="outlined"
                  label="UNIDADES"
                  required
                  fullWidth
                  value={formDescricaoTecnica.formState.values.unidades}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="unidades"
                  onChange={(e) => {
                    const input = e.target.value
                    const regex = /^[1-9]\d*$/ // Somente dígitos inteiros maiores que zero
                    if (regex.test(input) || input === '') {
                      formDescricaoTecnica.handleChange(e)
                    }
                  }}
                  error={formDescricaoTecnica.hasError('unidades')}
                  helperText={
                    formDescricaoTecnica.hasError('unidades')
                      ? formDescricaoTecnica.formState.errors.unidades[0]
                      : null
                  }
                />
              </Grid>
            </Grid>
            
            <Grid item container xs={12} spacing={2}>
              <Grid item md={3} sm={4} xs={12}>
                <TextField
                  variant="outlined"
                  label="QUANTIDADE (PESO OU VOLUME)"
                  required
                  fullWidth
                  value={formDescricaoTecnica.formState.values.quantidade}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="quantidade"
                  onChange={(e) => {
                    const input = e.target.value
                    const regex = /^\d*\.?\d*$/ // Permite números decimais
                    if (regex.test(input)) {
                      formDescricaoTecnica.handleChange(e)
                    }
                  }}
                  error={formDescricaoTecnica.hasError('quantidade')}
                  helperText={
                    formDescricaoTecnica.hasError('quantidade')
                      ? formDescricaoTecnica.formState.errors.quantidade[0]
                      : null
                  }
                />
              </Grid>

              <Grid item md={3} sm={4} xs={12}>
                <Autocomplete
                  value={formDescricaoTecnica.formState.values.unidadeQuantidade || null}
                  name="unidadeQuantidade"
                  noOptionsText="Sem informações"
                  options={['g', 'ml']}
                  onChange={(event, newValue) => {
                    formDescricaoTecnica.handleChangeNewValueByNameProperty(
                      event,
                      newValue,
                      'unidadeQuantidade'
                    )
                  }}
                  getOptionLabel={(option) => option}
                  renderOption={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder={formDescricaoTecnica.formState.values.unidadeQuantidade || 'Selecionar...'}
                      label="UNIDADE DE MEDIDA"
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={formDescricaoTecnica.hasError('unidadeQuantidade')}
                      helperText={
                        formDescricaoTecnica.hasError('unidadeQuantidade')
                          ? formDescricaoTecnica.formState.errors.unidadeQuantidade[0]
                          : null
                      }
                    />
                  )}
                  className={classes.tipoVestigio}
                />
              </Grid>
            </Grid>

            <Grid className={classes.fieldGroup} item container xs={12}>
              <Grid item xs={12}>
                <Typography variant="body2">
                  <strong>QUANTIFICAÇÃO DE CONTRAPROVA</strong>
                </Typography>
              </Grid>
              <FormControl component="fieldset" fullWidth>
                <RadioGroup
                  aria-label="quantificacao-contraprova"
                  name="quantificacaoContraprova"
                  value={formDescricaoTecnica.formState.values.quantificacaoContraprova || null}
                  onChange={formDescricaoTecnica.handleChange}
                  style={{ display: 'flex', flexDirection: 'row' }}
                >
                  <FormControlLabel
                    value="RESTANTE"
                    control={<Radio />}
                    label={<Typography variant="body2">TODO O RESTANTE</Typography>}
                  />
                  <FormControlLabel
                    value="ESPECIFICADO"
                    control={<Radio />}
                    label={<Typography variant="body2">ESPECIFICAR</Typography>}
                  />
                  <FormControlLabel
                    value="CONSUMIDO"
                    control={<Radio />}
                    label={<Typography variant="body2">TOTALMENTE CONSUMIDO</Typography>}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item container xs={12} spacing={2}>
              <Grid item md={3} sm={4} xs={12}>
                <TextField
                  variant="outlined"
                  label="QUANTIDADE CONTRAPROVA"
                  required
                  disabled={
                    formDescricaoTecnica.formState.values.quantificacaoContraprova === 'RESTANTE' ||
                    formDescricaoTecnica.formState.values.quantificacaoContraprova === 'CONSUMIDO'
                  }
                  fullWidth
                  value={formDescricaoTecnica.formState.values.quantidadeContraprova}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="quantidadeContraprova"
                  onChange={(e) => {
                    const input = e.target.value
                    const regex = /^\d*\.?\d*$/
                    if (regex.test(input)) {
                      formDescricaoTecnica.handleChange(e)
                    }
                  }}
                  error={formDescricaoTecnica.hasError('quantidadeContraprova')}
                  helperText={
                    formDescricaoTecnica.hasError('quantidadeContraprova')
                      ? formDescricaoTecnica.formState.errors.quantidadeContraprova[0]
                      : null
                  }
                />
              </Grid>

              <Grid item md={3} sm={4} xs={12}>
                <Autocomplete
                  value={formDescricaoTecnica.formState.values.unidadeQuantidadeContraprova || null}
                  name="unidadeQuantidadeContraprova"
                  disabled={
                    formDescricaoTecnica.formState.values.quantificacaoContraprova === 'RESTANTE' ||
                    formDescricaoTecnica.formState.values.quantificacaoContraprova === 'CONSUMIDO'
                  }
                  noOptionsText="Sem informações"
                  options={['g', 'mL']}
                  onChange={(event, newValue) => {
                    formDescricaoTecnica.handleChangeNewValueByNameProperty(
                      event,
                      newValue,
                      'unidadeQuantidadeContraprova'
                    )
                  }}
                  getOptionLabel={(option) => option}
                  renderOption={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder={
                        formDescricaoTecnica.formState.values.unidadeQuantidadeContraprova || 'Selecionar...'
                      }
                      label="UNIDADE DE MEDIDA"
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={formDescricaoTecnica.hasError('unidadeQuantidadeContraprova')}
                      helperText={
                        formDescricaoTecnica.hasError('unidadeQuantidadeContraprova')
                          ? formDescricaoTecnica.formState.errors.unidadeQuantidadeContraprova[0]
                          : null
                      }
                    />
                  )}
                  className={classes.tipoVestigio}
                />
              </Grid>

              <Grid item md={3} sm={4} xs={12}>
                <TextField
                  variant="outlined"
                  label="LACRE CONTRAPROVA"
                  required
                  fullWidth
                  value={formDescricaoTecnica.formState.values.lacreContraprova}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={formDescricaoTecnica.formState.values.quantificacaoContraprova === 'CONSUMIDO'}
                  name="lacreContraprova"
                  onChange={formDescricaoTecnica.handleChange}
                  error={formDescricaoTecnica.hasError('lacreContraprova')}
                  helperText={
                    formDescricaoTecnica.hasError('lacreContraprova')
                      ? formDescricaoTecnica.formState.errors.lacreContraprova[0]
                      : null
                  }
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} spacing={2}>
              <Grid className={classes.fieldGroup} item container xs={12}>
                <Grid item xs={12}>
                  <Typography variant="body2">
                    <strong>GEROU ANEXO?</strong>
                  </Typography>
                </Grid>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup
                    aria-label="anexo"
                    name="anexo"
                    value={formDescricaoTecnica.formState.values.anexo || null}
                    onChange={formDescricaoTecnica.handleChange}
                    style={{ display: 'flex', flexDirection: 'row' }}
                  >
                    <FormControlLabel
                      value="SIM"
                      control={<Radio />}
                      label={<Typography variant="body2">SIM</Typography>}
                    />
                    <FormControlLabel
                      value="NAO"
                      control={<Radio />}
                      label={<Typography variant="body2">NÃO</Typography>}
                    />
                  </RadioGroup>
                </FormControl>
                
                <Grid item xs={12}>
                  <TextField
                    disabled={!(formDescricaoTecnica.formState.values.anexo === 'SIM')}
                    variant="outlined"
                    label="LACRE DO ANEXO"
                    required
                    fullWidth
                    value={formDescricaoTecnica.formState.values.lacreAnexo}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="lacreAnexo"
                    onChange={formDescricaoTecnica.handleChange}
                    error={formDescricaoTecnica.hasError('lacreAnexo')}
                    helperText={
                      formDescricaoTecnica.hasError('lacreAnexo')
                        ? formDescricaoTecnica.formState.errors.lacreAnexo[0]
                        : null
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  )
}

FormDescricaoVestigioQuimico.propTypes = {
  formDescricaoTecnica: PropTypes.object.isRequired,
}
